import { createApi } from "@reduxjs/toolkit/query/react";
import { api } from "../../../api/Api.jsx";

export const Statsistik = createApi({
    reducerPath: 'Statsistik',
    baseQuery: api,  
    tagTypes: ['Statsistik'],
    endpoints: (build) => ({
        getStatsistik: build.query({
            query: (body) => `students/get_all_statistics`,
            providesTags: ['tagTypes'],

        }),
      
    }),
});

export const {
 useGetStatsistikQuery,

} = Statsistik;